<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
  <mask id="mask0_2735_15632" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
    <rect width="32" height="32" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_2735_15632)">
    <path
      d="M5.33332 29.3333C4.59999 29.3333 3.97221 29.0722 3.44999 28.55C2.92777 28.0277 2.66666 27.4 2.66666 26.6666V13.3333C2.66666 12.6 2.92777 11.9722 3.44999 11.45C3.97221 10.9277 4.59999 10.6666 5.33332 10.6666H7.99999V2.66663H18.6667V7.99996H10.6667V18.6666H13.3333V10.6666H26.6667C27.4 10.6666 28.0278 10.9277 28.55 11.45C29.0722 11.9722 29.3333 12.6 29.3333 13.3333V26.6666C29.3333 27.4 29.0722 28.0277 28.55 28.55C28.0278 29.0722 27.4 29.3333 26.6667 29.3333H5.33332Z"
      attr.fill="{{ color }}" />
  </g>
</svg>
